import * as React from "react";

function StoreIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: props.color || 'current',
    viewBox: "0 0 32 32",
    "aria-hidden": "true",
    width: props.width || '32px'
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'current',
    fillRule: "evenodd",
    d: "M4.246 4h23.36l.225.69.091.282a332.805 332.805 0 01.972 3.04c.266.846.533 1.713.735 2.403.1.343.186.65.248.892.031.12.058.232.079.33.014.068.044.216.044.363v6h-2v10H12V18H6v10H4V18H2v-6.14L4.246 4zM10 16v-5H8v5H4v-3.86L5.754 6h20.399l.106.33c.199.616.463 1.441.727 2.282.264.842.527 1.694.723 2.364.098.336.178.619.231.829.027.105.046.184.057.236l.003.016V16h-4v-5h-2v5h-5v-5h-2v5h-5zm5 2h11v8H14v-8h1z",
    clipRule: "evenodd"
  }));
}

export default StoreIcon;